import { BetsMessageType } from '../constants';
import { subscribeToBets } from './bets_subscriber';

export const subscribeToEventBets = (eventId, callbacks) => subscribeToBets(({ data, type }) => {
  if (type === BetsMessageType.NEW && data?.eventIds?.includes?.(eventId)) {
    callbacks.new();
  } else if (type === BetsMessageType.SETTLED) {
    callbacks.settled();
  }
});
